<template>
  <div class="item" @click="cilckFunc">
    <span class="description" v-if="description">{{ description }}</span>
    <span class="right-description" v-if="rightDescription">{{ rightDescription }}</span>
    <div class="center">
      <span class="title">
        {{ type }}
      </span>
      <span class="wapper">
        <span class="amount">
          {{ amount||'?' }} 
        </span>
        <span class="unit">
          {{ unit }}
        </span>
      </span>
    </div>
    <div class="bottom">
      <span class="valid-time">
        {{ validTime }}
      </span>
      <span class="intrest-day">
        {{ intrestDay }}
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'quan-item',
  props: {
    description: '',
    rightDescription: '',
    type: '',
    amount: '',
    validTime: '', 
    intrestDay: '', 
    unit: ''
  }, 
  methods: {
    cilckFunc () {
      this.$emit('click')
    }
  }
}
    
</script>
<style lang='less' scoped>
@import "../../../assets/less/mixin.less";

      .item {
        position: relative;
        width: 670px;
        min-height: 180px;
        background-image: url(./../images/quan_bg.png);
        margin: 40px 40px 0px 40px;
        background-size: 100% 100%;
        border-radius:20px;
        overflow: hidden;

        .description {
          font-size: 20px;
          font-family: PingFangSC-Regular,PingFang SC;
          font-weight: 400;
          color:rgba(255,255,255,1);
          line-height: 40px;
          padding: 0 15px;
          height: 40px;
          background-color: #FF756F; 
          position: absolute;
          top: 0;
          left: 0;
          background: linear-gradient(90deg, #FD7A16 0%, #FFB35C 100%);
          border-radius: 20px 0px 20px 0px;
        }

        .right-description {
          padding: 6px 20px;
          background-image: url('./img_fanxain@2x.png');
          position: absolute;
          right: 5px;
          height: 55px;
          background-repeat: round;
          background-size:100%;
          font-size: 20px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 28px;
        }

        .center {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          margin-top: 61px;
          padding-left: 33px;

          .title {
            font-size: 34px;
            font-family: PingFangSC-Semibold,PingFang SC;
            font-weight: 600;
            color: rgba(255,255,255,1);
            line-height: 61px;
          }

          .wapper {
            padding-right: 40px;

            .amount {
              font-size: 50px;
              font-family:DIN-Medium,DIN;
              font-weight: 500;
              color:rgba(255,255,255,1);
              line-height: 61px;
            }

            .unit {
              font-size: 28px;
              font-family: PingFangSC-Medium,PingFang SC;
              font-weight: 500;
              color: rgba(255,255,255,1);
              line-height: 40px;
            }
          }
        }
        .bottom {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          padding-left: 33px;
          margin: 17px 0 10px;
          font-size: 20px;
          .valid-time {
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(255,255,255,1);
            line-height:28px;
          }

          .intrest-day {
            padding-right: 40px;
            padding-left: 50px;
            font-size:20px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(255,255,255,1);
            line-height:28px;
          }
        }
      }
</style>